
import { Model } from 'backbone';
import Immutable from 'immutable';

class UserDetailsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default UserDetailsModel;
